import { NetworkException, inject, needs } from "fw";
import { dispatch } from "fw-state";
import { UserRepository } from "network/user-repository";
import { ConfirmChangeEmailAction, ConfirmChangeEmailForm } from "forms/confirm-change-email";
import { LoginFooter } from "./login-footer";
import { LogoutAction } from "state/actions";

@inject
@needs(LoginFooter)
export class ConfirmChangeEmail {
    private changeEmailForm: ConfirmChangeEmailForm = null;
    private existingEmailAddress: string = null;
    private isChanging: boolean = false;
    private isDone: boolean = false;
    private isError: boolean = false;
    private isLoading: boolean = false;
    private pendingEmailAddress: string = null;
    private showValidation: boolean = false;
    private token: string = null;

    public constructor(private userRepo: UserRepository) {}

    public created() {
        this.changeEmailForm = new ConfirmChangeEmailForm();
    }

    public async activate(params: { token: string }) {
        try {
            this.isLoading = true;
            await dispatch(new LogoutAction("", false));

            this.token = params.token;
            const result = await this.userRepo.changeEmail(params.token);
            this.existingEmailAddress = result.ExistingEmailAddress;
            this.pendingEmailAddress = result.PendingEmailAddress;
        } catch (err) {
            this.isError = true;
        } finally {
            this.isLoading = false;
        }
    }

    public async confirmEmailChange() {
        try {
            this.isChanging = true;
            await dispatch(new ConfirmChangeEmailAction(this.changeEmailForm, this.token));
            this.isDone = true;
        } catch (err) {
            let message = "Could not confirm the change email address";
            if (err instanceof NetworkException) {
                this.showValidation = true;

                switch (err.result.Code) {
                    case "BADREQUEST":
                    case "CONFLICT":
                        message = err.result.Message;
                        break;
                }
            }

            this.changeEmailForm.isInvalid = true;
            this.changeEmailForm.validationMessages = [message];
        } finally {
            this.isChanging = false;
        }
    }
}
